<template>
  <div id="profileInSitePage">
    <NavBar class="overflow-y-hidden"/>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <v-main class="overflow-hidden">
          <div class="container-fluid">
            <div v-if="isLoaded" class="row ">
              <div class="col-4 text-center">
                <v-avatar size="80">
                  <img v-if="profileInfo.FileUrl !== null" :src="$replaceHttps(profileInfo.FileUrl)" alt="لوگو کاربر">
                  <i v-else class="fas fa-circle-user fa-5x"></i>
                </v-avatar>
                <div class="row">
                  <div class="col-md-8 mx-auto">
                    <v-btn :class="isFollow ? true :'black--text'" :color="isFollow ? 'primary':'white'" block
                           class="rounded-lg" depressed
                           small @click="follow">
                      <span v-if="isFollow">دنبال شد</span>
                      <span v-else>دنبال کردن</span>
                    </v-btn>
                  </div>
                  <div class="py-1  col-12 pointer " @click="openFollowersSheet = true">{{ todayFollowerCount }} دنبال
                    کننده
                  </div>
                  <div class="py-1  col-12  px-0">{{ profileDetail.Views }} مشاهده</div>
                </div>

              </div>
              <div class="col-8  ">
                <h1 v-if="profileDetail.Name !== null" class="primary-text">{{ profileInfo.Name }} {{
                    profileInfo.Family
                  }} <i v-if="profileDetail.IsVerified" class="fa-solid fa-badge-check mr-1"></i></h1>
                <h1 v-else class="primary-text " dir="ltr">{{ profileInfo.PhoneNumber.slice(0, 5) }} ***
                  {{ profileInfo.PhoneNumber.slice(7, 10) }} <i v-if="profileInfo.IsVerified"
                                                                class="fa-solid fa-badge-check mr-1"></i></h1>
                <div v-html="profileDetail.WorkField"></div>
                <div v-if="profileDetail.Bio !== null" class="line-before mt-2">Bio</div>
                <div class="brand-info-description" v-html="profileDetail.Bio"></div>
                <div v-if="profileDetail.MobilePhone !== null" class="line-before py-2"><i
                    class="fal fa-phone-volume font-weight-bold"></i>
                  <div><span class="" @click="openPhone(profileDetail.MobilePhone)">
          {{ profileDetail.MobilePhone }}</span><span
                      v-if=" profileDetail.StaticPhone !== 'null'"
                      class=" mr-5 pr-5" @click="openPhone(profileDetail.StaticPhone)">
          {{ profileDetail.StaticPhone }}</span>
                  </div>
                </div>
                <div v-if="profileDetail.Address !== null" class="line-before "><i
                    class="fal fa-map-marker-alt font-weight-bold pointer"
                    @click="openMap(profileDetail.Latitude,profileDetail.Longitude)"></i>
                </div>
                <div @click="openExternalMap(profileDetail.Latitude,profileDetail.Longitude)">
              <span v-html="profileDetail.Address">

              </span>
                  <!--              - پلاک {{ profileDetail.Plak }} - واحد
                                {{ profileDetail.Vahed }}-->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-8  mx-auto">
                <div class="d-flex justify-space-around primary-border-top py-3">
                  <div class="text-center"><i :class="showGalleryTab ? 'font-weight-bold':''"
                                              class="fa-2xl far fa-photo-film pointer"
                                              @click="galleryTab"></i>
                    <div class="font12px mt-3">گالری</div>
                  </div>
                  <div class="text-center"><i :class="showCommentsTab ? 'font-weight-bold':''"
                                              class="fa-2xl far fa-file-check pointer"
                                              @click="commentsTab"></i>
                    <div class="font12px mt-3">نمرات به محصولات</div>
                  </div>
                  <div class="text-center"><i :class="showBookmarksTab ? 'font-weight-bold':''"
                                              class="fa-2xl far fa-bookmark pointer"
                                              @click="bookmarksTab"></i>
                    <div class="font12px mt-3">محصولات مورد علاقه</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showGalleryTab">
              <div class="row">
                <div class="col pt-0 ">
                  <v-autocomplete
                      v-model="searchKeyWordPosts"
                      :items="hashtagsItems"
                      append-icon="far fa-magnifying-glass"
                      class="rounded-lg search-combobox"
                      clearable
                      dense
                      flat
                      hide-details
                      item-text="Content"
                      item-value="HashTagID"
                      placeholder="..Search Hashtag"
                      solo
                      @change="searchPosts"
                      @keyup="searchPosts"
                      @click:clear="removeSearchHistoryPosts">
                  </v-autocomplete>

                </div>
                <div class="col-auto pt-0 pr-1">
                  <v-btn icon @click="openFilterSheet = true">
                    <i class="fa-solid fa-sliders fa-xl"></i>
                  </v-btn>
                </div>
              </div>
              <div v-if="!hasResultPost" class="col-12 text-center">
                نتیجه ای یافت نشد
              </div>
              <div v-else-if="postsItems.length=== 0" class="col-12  mt-10  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  موردی یافت نشد
                </div>

              </div>
              <masonry v-else
                       :cols="{default: 4, 1000: 3, 700: 2}">
                <router-link v-for="(item,i) in postsItems" :key="i"
                             :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID}}"
                             class="p-1 mx-auto d-block">
                  <v-img v-if="item.FileCoverUrl !== null"
                         :lazy-src="$replaceHttps(item.FileCoverUrl)"
                         :src="$replaceHttps(item.FileCoverUrl)"
                         class=" rounded-11px">
                    <div class="p-2">
                      <div v-if="item.TypeStrucGallery ===2"><i
                          class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                      <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                      </div>
                    </div>
                  </v-img>
                  <v-img v-else :lazy-src="$replaceHttps(item.FileUrl)" :src="$replaceHttps(item.FileUrl)"
                         class=" rounded-11px">
                    <div class="p-2">
                      <div v-if="item.TypeStrucGallery ===2"><i
                          class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                      <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                      </div>
                    </div>
                  </v-img>
                </router-link>
              </masonry>
              <v-bottom-sheet v-model="openFilterSheet" class="bottom-sheet">
                <v-sheet
                    class="rounded-t-xl">
                  <div class="row no-gutters align-items-center">
                    <div class="col-auto font-weight-bold pr-8 primary-text">
                      <i class="fa-solid fa-sliders fa-xl"></i>
                    </div>
                    <div class="col pr-5 py-2 toggle-filter-btn">
                      <v-btn-toggle
                          v-model="filterSelected"
                          group
                          tile
                          @change="filterSelectedGallery">
                        <v-btn value="0">
                          همه
                        </v-btn>
                        <v-btn value="1">
                          عکس
                        </v-btn>
                        <v-btn value="2">
                          فیلم
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                    <div class="col text-left pl-4">
                      <v-btn
                          icon
                          @click="openFilterSheet = !openFilterSheet">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
                      </v-btn>
                    </div>
                  </div>

                </v-sheet>
              </v-bottom-sheet>

            </div>
            <div v-if="showCommentsTab" class="row">
              <div class="col pt-0 ">
                <v-text-field
                    v-model="searchVotedKeyword"
                    append-icon="far fa-magnifying-glass"
                    class="rounded-lg"
                    clearable
                    dense
                    flat
                    hide-details
                    placeholder="Search Product Name..."
                    solo
                    @keyup="searchVoted"
                    @click:clear="removeSearchHistoryVoted">
                </v-text-field>
              </div>
              <div class="col-auto pt-0 pr-1">
                <v-btn icon @click="openSortBoxVotedProducts">
                  <i class="fa-solid fa-sliders fa-xl"></i>
                </v-btn>
              </div>
              <div v-if="!hasResultVoted" class="col-12 text-center">
                نتیجه ای یافت نشد
              </div>
              <div v-else-if="comments.length <= 0" class="col-12  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  هنوز نظری ثبت نشده است
                </div>

              </div>
              <div v-else class="col-12 mx-1">
                <div v-for="(item,i) in comments" :key="i" class="row ">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-4 p-1">
                        <v-img :lazy-src="$replaceHttps(item.VendorProduct.FileUrl)"
                               :src="$replaceHttps(item.VendorProduct.FileUrl)"
                               aspect-ratio="1"
                               class="rounded-lg">
                        </v-img>
                      </div>
                      <div class="col-8 px-0 d-flex flex-column justify-space-between pl-2">
                        <div class="d-flex justify-space-between">
                          <div class="primary-text text-truncate">{{ item.VendorProduct.Name }}</div>
                          <div><i class="fa-solid fa-star yellow--text ml-1"></i>{{ item.avgVote }}</div>
                        </div>
                        <div class="d-flex"><span v-if="item.VendorProduct.VendorProductTipViewModels[0].Discount !== 0"
                                                  class="product-card-discount rounded-circle m-0">
        {{ item.VendorProduct.VendorProductTipViewModels[0].Discount }} %</span>
                          <span v-if="item.VendorProduct.VendorProductTipViewModels[0].Discount !== 0"
                                class="font12px pt-2 text-decoration-line-through grey--text mr-3">
                              {{ item.VendorProduct.VendorProductTipViewModels[0].Price }}</span>
                        </div>
                        <div class="d-flex justify-space-between">
                          <div>{{
                              $computingPriceOffer(item.VendorProduct.VendorProductTipViewModels[0].Price, item.VendorProduct.VendorProductTipViewModels[0].Discount)
                            }} تومان
                          </div>
                          <router-link :to="{name:'ProductDetail',query:{VendorProductID:item.RelationID}}">
                            <i class="fa-solid fa-eye"></i> مشاهده کامل
                          </router-link>
                        </div>

                      </div>
                    </div>
                    <div class="row">
                      <div class="col-9 bg-white rounded-lg pl-1">
                        <v-avatar size="38">
                          <img v-if="item.AppUserUrl !== null" :src="$replaceHttps(item.AppUserUrl)"
                               alt="تصویر کاربر">
                          <i v-else class="fas fa-circle-user fa-3x"></i>
                        </v-avatar>
                        <span class="font-weight-bold mr-1"> {{ profileInfo.Name }} {{ profileInfo.Family }} <i
                            v-if="profileInfo.IsVerified" class="fa-solid fa-badge-check mr-1"></i>:</span>
                        <span class="font-weight-normal">{{ item.Description }}</span>
                      </div>
                      <div class="col-3 text-left">
                        <div>{{ $convertDate(item.ModifiedDate) }}</div>
                        <div>{{ item.Rate }} <i class="fa-solid fa-star yellow--text"></i></div>
                      </div>
                      <div class="col-12">
                        <div v-if="item.AnswerDescription !== null" class="row">
                          <div class="col-1"><i class="fa-solid fa-arrow-turn-down-left fa-lg"></i></div>
                          <div class="col-8 bg-white rounded-lg pb-0">
                            <v-avatar size="38">
                              <img v-if="item.VendorProduct.VoteViewModel[0].VendroPictureUrl !== null"
                                   :src="$replaceHttps(item.VendorProduct.VoteViewModel[0].VendroPictureUrl)"
                                   alt="تصویر پاسخ دهنده">
                              <i v-else class="fas fa-circle-user fa-3x"></i>
                            </v-avatar>
                            <span class="font-weight-bold mr-1"> {{ item.VendorProduct.VendorName }} <i
                                v-if="item.IsVerified"
                                class="fa-solid fa-badge-check mr-1"></i>:</span>
                            <span class="font-weight-normal">{{ item.AnswerDescription }}</span>

                          </div>
                          <div class="col-3 text-left py-0 reply-comments-action px-0">
                            <div>
                              <span class="d-inline-block w-50">{{ item.CountLike }}</span>
                              <v-btn class="d-inline-block w-50" icon small><i
                                  class="fa-solid fa-thumbs-up fa-xl  green--text"></i></v-btn>
                            </div>
                            <div>
                              <span class="d-inline-block w-50">{{ item.CountDislike }}</span>
                              <v-btn class="d-inline-block w-50" icon small><i
                                  class="fa-solid fa-thumbs-down fa-xl  red--text"></i></v-btn>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showBookmarksTab" class="row">
              <div class="col pt-0 ">
                <v-text-field
                    v-model="searchBookMarkKeyword"
                    append-icon="far fa-magnifying-glass"
                    class="rounded-lg"
                    clearable
                    dense
                    flat
                    hide-details
                    placeholder="Search Name..."
                    solo
                    @keyup="searchBookMarkPost"
                    @click:clear="removeSearchHistory">
                </v-text-field>
              </div>
              <div class="col-auto pt-0 pr-1">
                <v-btn icon @click="openSortBox">
                  <i class="fa-solid fa-sliders fa-xl"></i>
                </v-btn>
              </div>
              <div v-if="!hasResult" class="col-12 text-center">
                نتیجه ای یافت نشد
              </div>
              <div v-else class="col-12">
                <div class="row">
                  <router-link v-for="(item,i) in bookmarkList"
                               :key="i" :to="{name:'ProductDetail',query:{VendorProductID:item.RelationID}}"
                               class="col-4 p-1">
                    <v-img :lazy-src="$replaceHttps(item.FileUrl)"
                           :src="$replaceHttps(item.VendorProduct.FileUrl)"
                           aspect-ratio="1"
                           class="rounded-lg">
                      <div class="d-flex flex-column align-items-end justify-content-end px-3" style="height: 100%">
                        <div><i class="fa-solid fa-star yellow--text"></i> {{ $roundNum(item.avgVote) }}

                        </div>

                      </div>
                    </v-img>
                  </router-link>

                </div>
              </div>
            </div>
          </div>
        </v-main>
      </div>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
    <div id="sortBox" class="sort-box bg-white p-2">
      <v-btn icon @click="closeSortBox">
        <i class="fa-solid fa-circle-xmark fa-xl"></i>
      </v-btn>
      <div class="row mx-2 light-gray-bg  rounded-lg ">
        <div class="col-3 "><i class="fa-solid fa-sliders fa-xl"></i></div>
        <div class="col-9 ">مرتب سازی</div>
      </div>
      <v-radio-group v-model="typeSortSelected">
        <v-radio
            v-for="(item,i) in sortItems"
            :key="i+1"
            :label="item"
            :value="i+1"
            @change="sort(i+1)"
        ></v-radio>
      </v-radio-group>
    </div>
    <div id="sortBoxVotedProducts" class="sort-box bg-white p-2">
      <v-btn icon @click="closeSortBoxVotedProducts">
        <i class="fa-solid fa-circle-xmark fa-xl"></i>
      </v-btn>
      <div class="row mx-2 light-gray-bg  rounded-lg ">
        <div class="col-3 "><i class="fa-solid fa-sliders fa-xl"></i></div>
        <div class="col-9 ">مرتب سازی</div>
      </div>
      <v-radio-group v-model="typeSortSelectedVoted">
        <v-radio
            v-for="(item,i) in sortItems"
            :key="i+1"
            :label="item"
            :value="i+1"
            @change="sortVoted(i+1)"
        ></v-radio>
      </v-radio-group>
    </div>
    <v-bottom-sheet v-model="openFollowersSheet" scrollable>
      <v-sheet
          class="rounded-t-xl overflow-y-auto overflow-x-hidden">
        <div class="row align-items-center">
          <div class="col-auto font-weight-bold pr-8 primary-text">
            {{ todayFollowerCount }} دنبال کننده
          </div>
          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="openFollowersSheet = !openFollowersSheet">
              <i class="fa-solid fa-circle-xmark fa-xl"></i>
            </v-btn>
          </div>
        </div>
        <div class="col-12">
          <div v-for="(item,i) in followers" :key="i" class="row align-items-center">
            <router-link v-if="item.UserRole === 'Client'" :to="{path:'ProfileInSite',query:{ID:item.AppUserID}}"
                         class="col-2 ">
              <v-avatar size="45">
                <img v-if="item.UserImageUrl !== null" :src="$replaceHttps(item.UserImageUrl)" alt="تصویر کاربر">
                <i v-else class="fas fa-circle-user fa-4x"></i>
              </v-avatar>
            </router-link>
            <router-link v-else :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}" class="col-2 ">
              <v-avatar size="45">
                <img v-if="item.VendorImageUrl !== null" :src="$replaceHttps(item.VendorImageUrl)" alt="تصویر فروشگاه">
                <i v-else class="fas fa-circle-user fa-4x"></i>
              </v-avatar>
            </router-link>
            <div class="col-7">
                  <span class="font-weight-bold mr-1" dir="ltr"> <i v-if="item.IsVerified"
                                                                    class="fa-solid fa-badge-check mr-1"></i>  {{
                      item.VendorName
                    }}</span>
              <div v-if="item.UserRole === 'Client'" class="text-truncate font12px m-0 bio-text"
                   v-html=" item.UserBio"></div>
              <div v-else class="text-truncate font12px m-0 bio-text" v-html=" item.VendorBio"></div>
            </div>
            <div class="col-3">
              <v-btn block v-if="(item.UserRole === 'Vendor' )&& item.isFollowed ===false" elevation="0" small
                     @click="followVendor(item.VendorID,item)">دنبال کردن
              </v-btn>
              <v-btn block v-else-if="item.UserRole === 'Client' && item.isFollowed ===false" elevation="0" small
                     @click="followUser(item.AppUserID,item)">دنبال کردن
              </v-btn>
              <v-btn block v-else-if="item.UserRole === 'Client' && item.isFollowed" color="primary" elevation="0" small
                     @click="followUser(item.AppUserID,item)">دنبال شد
              </v-btn>
              <v-btn block v-else-if="(item.UserRole === 'Vendor' ) && item.isFollowed" color="primary"
                     elevation="0" small
                     @click="followVendor(item.VendorID,item)">دنبال شد
              </v-btn>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";

export default {
  name: "ProfileInSite",
  metaInfo: {
    title: 'ایوان خانه- پروفایل کاربر',
  },
  components: {NavBar},
  data: () => ({
    showLoaderDialog: false,
    showResult: false,
    resultText: null,
    showBookmarksTab: false,
    showCommentsTab: false,
    showGalleryTab: true,
    isFollow: false,
    isLoaded: false,
    profileInfo: {},
    profileDetail: {},
    openFilterSheet: false,
    filterSelected: '0',
    comments: [],
    bookmarkList: [],
    todayFollowerCount: null,
    sortItems: ['پیش فرض', 'جدیدترین', 'کمترین قیمت', 'بیشترین قیمت', 'بیشترین فروش', 'بیشترین بازدید', 'محبوب ترین'],
    typeSortSelected: 1,
    typeSortSelectedVoted: 1,
    favoritesProducts: [],
    searchBookMarkKeyword: null,
    searchVotedKeyword: null,
    hasResult: true,
    postsItems: [],
    allPostList: [],
    AllComments: [],
    hashtagsItems: [],
    hasResultVoted: true,
    searchKeyWordPosts: null,
    hasResultPost: true,
    openFollowersSheet: false,
    followers: []

  }),
  mounted() {
    this.getProfileData()
    this.checkUserFollowing()
    this.getFavoriteProducts()
    this.getVotedProducts()

  },

  watch: {
    '$route.query'() {
      this.getProfileData()
      this.checkUserFollowing()
      this.getFavoriteProducts()
      this.getVotedProducts()
      this.openFollowersSheet = false
    },
  },
  methods: {
    checkUserFollowing() {
      let following = this.$store.getters.getUserFollowings
      let id = this.$route.query.ID
      if (following.find(x => x.FollowedAppUserId === id) !== undefined) {
        this.isFollow = true
      }
    },
    getProfileData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("appuserid", this.$route.query.ID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/ClientProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.todayFollowerCount = json.todayFollowerCount
            let followers = json.followers.reverse()


            let followings = this.$store.getters.getUserFollowings
            if (followers.length > 0) {
              for (let i = 0; i < followers.length; i++) {
                if (followers[i].UserRole === "Vendor") {
                  if (followings.find(x => x.VendorID === followers[i].VendorID) !== undefined) {
                    followers[i].isFollowed = true
                  } else {
                    followers[i].isFollowed = false
                  }
                } else {
                  if (followings.find(x => x.FollowedAppUserId === followers[i].AppUserID) !== undefined) {
                    followers[i].isFollowed = true
                  } else {
                    followers[i].isFollowed = false
                  }
                }
              }
            }
            this.followers = followers
            this.profileDetail = json.clientProfile
            this.profileInfo = json.model

            // this.bookmarkList =json.favoriteProducts.filter(x=>x.IsActive ===true)
            let posts = json.posts.filter(x => x.IsActive === true)
            this.postsItems = posts.sort(function (a, b) {
              return new Date(b.ModifiedDate) - new Date(a.ModifiedDate);
            });
            this.allPostList = json.posts.sort(function (a, b) {
              return new Date(b.ModifiedDate) - new Date(a.ModifiedDate);
            });
            this.showLoaderDialog = false
            let AllPostsHashtags = []
            for (let i = 0; i < json.posts.length; i++) {
              let selectedPostHashtags = json.posts[i].SelectedHashTags
              if (selectedPostHashtags !== null) {
                for (let j = 0; j < selectedPostHashtags.length; j++) {
                  AllPostsHashtags.push(selectedPostHashtags[j])
                }
              }
            }
            let postsHashtags = [...new Set(AllPostsHashtags)]
            let allHashtags = this.$store.getters.getHashtags
            let hashtagsItems = []
            for (let i = 0; i < postsHashtags.length; i++) {
              let findHashtag = allHashtags.find(x => x.HashTagID === postsHashtags[i])
              if (findHashtag !== undefined) {
                hashtagsItems.push(findHashtag)
              }
            }
            this.hashtagsItems = hashtagsItems
            this.isLoaded = true
            // let following = this.$store.getters.getUserFollowings
          })
          .catch(error => console.log('error', error));
    },
    follow() {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("FollowedAppUserId", this.$route.query.ID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.isFollow = !this.isFollow
              let payload = {id: this.$route.query.ID, type: 1}
              this.$store.commit('addOrRemoveFollowingItemToList', payload)
              this.getProfileData()
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    galleryTab() {
      this.showGalleryTab = true;
      this.showCommentsTab = false;
      this.showBookmarksTab = false
    },
    commentsTab() {
      this.showGalleryTab = false;
      this.showCommentsTab = true;
      this.showBookmarksTab = false
    },
    openPhone(tel) {
      this.$openLink("tel:" + tel)
    },
    bookmarksTab() {
      this.showGalleryTab = false;
      this.showCommentsTab = false;
      this.showBookmarksTab = true
    },
    openMap(lat, lng) {
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = "https://www.google.com.sa/maps/search/" + lat + ',' + lng + "?hl=en"
      a.target = '_blank'
      // a.download = <your_fileName>;
      a.click();
      document.body.removeChild(a);
    },
    openSortBox() {
      document.getElementById('sortBox').classList.add('open')
    },
    closeSortBox() {
      document.getElementById('sortBox').classList.remove('open')

    },
    openSortBoxVotedProducts() {
      document.getElementById('sortBoxVotedProducts').classList.add('open')
    },
    closeSortBoxVotedProducts() {
      document.getElementById('sortBoxVotedProducts').classList.remove('open')

    },
    getVotedProducts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("appuserid", this.$route.query.ID);
      urlencoded.append("TypeSearchEngineSort", this.typeSortSelectedVoted);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/ClientVotedProducts", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            for (let i = 0; i < json.length; i++) {
              let voteArr = json[i].VendorProduct.VoteViewModel
              if (voteArr !== null) {
                let num = voteArr.length
                let sumVote = 0

                for (let j = 0; j < voteArr.length; j++) {
                  sumVote += voteArr[j].Rate
                }
                let avg = sumVote / num;
                if (avg > 0) {
                  json[i].avgVote = sumVote / num
                } else {
                  json[i].avgVote = 0
                }
              } else {
                json[i].avgVote = 0
              }

            }
            this.comments = json
            this.AllComments = json
          })
          .catch(error => console.log('error', error));
    },
    getFavoriteProducts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("appuserid", this.$route.query.ID);
      urlencoded.append("TypeSearchEngineSort", this.typeSortSelected);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/ClientFavoriteProducts", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            for (let i = 0; i < json.length; i++) {
              let voteArr = json[i].VendorProduct.VoteViewModel
              if (voteArr !== null) {
                let num = voteArr.length
                let sumVote = 0

                for (let j = 0; j < voteArr.length; j++) {
                  sumVote += voteArr[j].Rate
                }
                let avg = sumVote / num;
                if (avg > 0) {
                  json[i].avgVote = sumVote / num
                } else {
                  json[i].avgVote = 0
                }
              } else {
                json[i].avgVote = 0
              }

            }
            this.bookmarkList = json
            this.favoritesProducts = json

          })
          .catch(error => console.log('error', error));
    },
    sort(i) {
      this.typeSortSelected = i
      this.closeSortBox()
      this.getFavoriteProducts()
    },
    sortVoted(i) {
      this.typeSortSelectedVoted = i
      this.closeSortBoxVotedProducts()
      this.getVotedProducts()
    },
    searchBookMarkPost() {
      let result = this.bookmarkList.filter(x => x.VendorProduct.Name.includes(this.searchBookMarkKeyword));
      if (this.searchBookMarkKeyword === '') {
        this.bookmarkList = this.favoritesProducts
      } else {
        if (result.length === 0) {
          this.hasResult = false
        } else {
          this.hasResult = true
          this.bookmarkList = result
        }
      }

    },
    searchVoted() {
      let result = this.comments.filter(x => x.VendorProduct.Name.includes(this.searchVotedKeyword));
      if (this.searchVotedKeyword === '') {
        this.comments = this.AllComments
      } else {
        if (result.length === 0) {
          this.hasResultVoted = false
        } else {
          this.hasResultVoted = true
          this.comments = result
        }
      }

    },
    removeSearchHistory() {
      this.bookmarkList = this.favoritesProducts
      this.hasResult = true
    },
    removeSearchHistoryVoted() {
      this.comments = this.AllComments
      this.hasResultVoted = true
    },
    searchPosts() {
      let allPosts = this.allPostList
      let result = []
      for (let i = 0; i < allPosts.length; i++) {
        if (allPosts[i].SelectedHashTags !== null) {
          let find = allPosts[i].SelectedHashTags.find(x => x === this.searchKeyWordPosts)
          if (find !== undefined) {
            result.push(allPosts[i])
          }
        }
      }
      if (this.searchKeyWordPosts === '' || this.searchKeyWordPosts === null) {
        this.postsItems = this.allPostList
        this.hasResultPost = true
      } else {
        if (result.length === 0) {
          this.hasResultPost = false
        } else {

          this.postsItems = result
        }
      }
    },
    removeSearchHistoryPosts() {
      this.searchKeyWord = null
      this.postsItems = this.allPostList
      this.hasResultPost = true
    },
    filterSelectedGallery() {
      let allPosts = this.allPostList
      if (this.filterSelected === '0') {
        this.postsItems = allPosts
      } else {
        this.postsItems = allPosts.filter(x => x.TypeStrucGallery === parseInt(this.filterSelected))
      }
    },
    followVendor(id, item) {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              item.isFollowed = !item.isFollowed
              let payload = {id: id, type: 2}
              this.$store.commit('addOrRemoveFollowingItemToList', payload)
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    followUser(id, item) {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("FollowedAppUserId", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              item.isFollowed = !item.isFollowed
              let payload = {id: id, type: 1}
              this.$store.commit('addOrRemoveFollowingItemToList', payload)
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },

  }
}
</script>

<style scoped>

</style>
